__turbopack_context__.v({
  "className": "dm_sans_c7b50280-module__bzOE1a__className",
  "variable": "dm_sans_c7b50280-module__bzOE1a__variable",
});
